// Mirrors UtilizationStatusEnum on the backend (numeric, not string, over the wire).
export enum UtilizationStatusEnum {
  NotAssessed = 0,
  Under = 1,
  Within = 2,
  Over = 3,
}

export const UTILIZATION_STATUS_LABELS: Record<UtilizationStatusEnum, string> = {
  [UtilizationStatusEnum.NotAssessed]: 'Not assessed',
  [UtilizationStatusEnum.Under]: 'Under',
  [UtilizationStatusEnum.Within]: 'Within',
  [UtilizationStatusEnum.Over]: 'Over',
};

// Mirrors ReserveTapSourceOperationEnum on the backend.
export enum ReserveTapSourceOperationEnum {
  FallbackWithdrawal = 0,
  SystemWalletTransfer = 1,
  BurningWalletFunding = 2,
  Staking = 3,
  ManualAction = 4,
  DayBoundarySwitchover = 5,
  UrgentDepositSweep = 6,
  WalletHandoff = 7,
}

export const RESERVE_CATEGORY_LABELS: Record<ReserveTapSourceOperationEnum, string> = {
  [ReserveTapSourceOperationEnum.FallbackWithdrawal]: 'Fallback withdrawals',
  [ReserveTapSourceOperationEnum.SystemWalletTransfer]: 'System wallet transfers',
  [ReserveTapSourceOperationEnum.BurningWalletFunding]: 'Burning wallet funding',
  [ReserveTapSourceOperationEnum.Staking]: 'Staking operations',
  [ReserveTapSourceOperationEnum.ManualAction]: 'Manual actions',
  [ReserveTapSourceOperationEnum.DayBoundarySwitchover]: 'Daily switchover',
  [ReserveTapSourceOperationEnum.UrgentDepositSweep]: 'Urgent deposit sweeps',
  [ReserveTapSourceOperationEnum.WalletHandoff]: 'Wallet handoffs',
};

export interface ReserveCategoryConsumption {
  category: ReserveTapSourceOperationEnum;
  energy: number;
  bandwidth: number;
}

export interface CurrentUtilization {
  date: string;
  consumedEnergy: number;
  consumedBandwidth: number;
  allocatedEnergy: number | null;
  allocatedBandwidth: number | null;
  energyUtilizationPercentage: number | null;
  bandwidthUtilizationPercentage: number | null;
  energyStatus: UtilizationStatusEnum;
  bandwidthStatus: UtilizationStatusEnum;
  reserveConsumptionByCategory: ReserveCategoryConsumption[];
}

export interface UtilizationReportRow {
  date: string;
  totalStakedEnergy: number;
  totalStakedBandwidth: number;
  consumedEnergy: number;
  consumedBandwidth: number;
  allocatedEnergy: number | null;
  allocatedBandwidth: number | null;
  energyUtilizationPercentage: number | null;
  bandwidthUtilizationPercentage: number | null;
  energyStatus: UtilizationStatusEnum;
  bandwidthStatus: UtilizationStatusEnum;
}

// GET report/utilization?fromDate&toDate.
export interface UtilizationReport {
  networkId: string;
  fromDate: string;
  toDate: string;
  rows: UtilizationReportRow[];
}
